export { SignTransactionDeviceActionFactory } from "@internal/app-binder/device-action/SignTransactionDeviceActionFactory";
